import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ApiResponse,
  CreateSubApplicationProps,
  DeleteSubApplication,
  SelectedSubApplication,
  SingleSubApplicationResponse,
} from '../sagas/subApplicationSaga';

export interface OperatorState {
  subApplications: ApiResponse;
  loading: boolean;
  error: boolean;
  subapplication: SingleSubApplicationResponse;
  selectedSubApplication: SelectedSubApplication;
}

export const initialState: OperatorState = {
  subApplications: {
    data: [],
    pagination: {
      totalRecords: 0,
      totalItems: 0,
      currentPage: 0,
      totalPages: 0,
      nextPage: 0,
      previousPage: 0,
    },
    success: false,
    message: '',
  },
  loading: false,
  error: false,
  subapplication: {
    name: '',
    id: '',
    createdOn: '',
    updatedOn: '',
  },
  selectedSubApplication: {
    name: '',
    id: '',
  },
};

const subapplicationSlice = createSlice({
  name: 'subapplication',
  initialState,
  reducers: {
    getSubApplications: (state, action: PayloadAction<any>) => {
      state.loading = true;
    },
    getSubApplicationsSuccess: (state, action: PayloadAction<ApiResponse>) => {
      state.loading = false;
      state.subApplications = { ...action.payload };
    },
    getSubApplicationsFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    getSubApplication: (state) => {
      state.loading = true;
    },
    getSubApplicationSuccess: (
      state,
      action: PayloadAction<SingleSubApplicationResponse>,
    ) => {
      state.loading = false;
      state.subapplication = { ...action.payload }; // Avoid direct assignment, create a new object
    },
    getSubApplicationFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    createSubApplication: (
      state,
      action: PayloadAction<CreateSubApplicationProps>,
    ) => {
      state.loading = true;
    },
    createSubApplicationSuccess: (
      state,
      action: PayloadAction<SingleSubApplicationResponse>,
    ) => {
      state.loading = false;
      state.subapplication = { ...action.payload }; // Avoid direct assignment, create a new object
    },
    createSubApplicationFailure: (state) => {
      state.loading = false;
      state.error = false;
    },
    updateSubApplication: (
      state,
      action: PayloadAction<CreateSubApplicationProps>,
    ) => {
      state.loading = true;
    },
    updateSubApplicationSuccess: (
      state,
      action: PayloadAction<SingleSubApplicationResponse>,
    ) => {
      state.loading = false;
      state.subapplication = { ...action.payload }; // Avoid direct assignment, create a new object
    },
    updateSubApplicationFailure: (state) => {
      state.loading = false;
      state.error = false;
    },
    selectedSubApplication: (
      state,
      action: PayloadAction<SelectedSubApplication>,
    ) => {
      state.loading = false;
      state = {
        ...state,
        selectedSubApplication: { ...action.payload },
      };
    },
    deleteSubApplication: (
      state,
      action: PayloadAction<DeleteSubApplication>,
    ) => {
      state.loading = true;
    },
    deleteSubApplicationSuccess: (
      state,
      action: PayloadAction<SingleSubApplicationResponse>,
    ) => {
      state.loading = false;
      state = {
        ...state,
        subApplications: {
          ...state.subApplications,
          data: state.subApplications.data.filter(
            (item) => item.id !== action.payload.id,
          ),
        },
      }; // Avoid direct assignment, create a new object
    },
    deleteSubApplicationFailure: (state) => {
      state.loading = false;
      state.error = false;
    },
  },
});

const subapplicationSliceReducer = subapplicationSlice.reducer;
export const {
  getSubApplications,
  getSubApplicationsSuccess,
  getSubApplicationsFailure,
  getSubApplication,
  getSubApplicationSuccess,
  getSubApplicationFailure,
  updateSubApplication,
  updateSubApplicationSuccess,
  updateSubApplicationFailure,
  selectedSubApplication,
  deleteSubApplication,
  deleteSubApplicationSuccess,
  deleteSubApplicationFailure,
} = subapplicationSlice.actions;
export default subapplicationSliceReducer;
